<template>
  <span>
    <el-popover placement="top-start" trigger="click" v-model="showPopover">
      <!-- <template slot="content"> -->
        <div class="emoji-box">
          <img
            v-for="(v,i) in emojiList"
            :src="require(`../../../static/faces/${v}`)"
            :key="i"
            @click="selectEmoji(i)"
            class="img-style"
          />
        </div>
      <!-- </template> -->
      <text class="el-icon-eleme" @click="showPopover = !showPopover"></text>
      <!-- <a-icon type="smile" :style="{ fontSize: '20px', color: 'rgba(0, 0, 0, 0.65)' }" @click="showPopover = !showPopover" /> -->
    </el-popover>
  </span>
</template>

<script>
import emoji from '../../utils/emoji';

export default{
	data(){
		return {
			emojiList: emoji.obj,
			showPopover: false
		};
	},
	methods: {
		selectEmoji(e){
			let value = (this.inpMessage || '') + e;
			this.showPopover = false
			this.$emit('selectEmoji', value);
		},
        open(){
            console.log('进来没')
          this.showPopover = !this.showPopover
        }
	},
	props: {
		inpMessage: String
	}
};
</script>
<style scoped>
.emoji-box {
  width: 360px;
}
.img-style {
  width: 22px;
  margin: 5px;
  cursor: pointer;
}
.img-style:hover {
  background-color: aquamarine;
}
</style>



// WEBPACK FOOTER //
// src/components/chatEmoji/index.vue